import { Component } from "react";

class SelectItem extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  render() {
    return (
      <div
        className={`select-item-lp--container ${
          this.props.actif ? "actif" : ""
        } ${this.props.position}`}
      >
        <div
          className={`select-item-lp--inner ${
            this.props.actif ? "actif" : ""
          } ${this.props.position}`}
        >
          <h2 className="select-item--content">{this.props.content}</h2>
        </div>
      </div>
    );
  }
}

export default SelectItem;
